import {ArticleTableOfContents} from './ArticleTableOfContents';
export default ArticleTableOfContents;
